import { useMemo, useState } from 'react';
import Fuse from 'fuse.js';

/**
 * Filtering select options and return props for Select component to make it searchable.
 */
const useSearchableSelectProps = (options = [], onSearch = null) => {
    const [search, setSearch] = useState(null);

    return useMemo(() => {
        const fuse = new Fuse(options, {
            keys: ['text'],
            threshold: 0.3
        });
        const trimmedSearch = (search || '').trim();
        const filteredOptions = fuse.search(trimmedSearch).map(({ item }) => item);

        return {
            selectProps: {
                options: trimmedSearch ? filteredOptions : options,
                onInputChange: ({ target: { value } }) => {
                    setSearch(value);
                    onSearch?.(value);
                },
                useNew: true,
                search: true
            },
            resetSearch: () => {
                setSearch(null);
                onSearch?.(null);
            }
        };
    }, [options, search, onSearch]);
};

export default useSearchableSelectProps;
